import { render, staticRenderFns } from "./opening-times.vue?vue&type=template&id=83c9c4cc&"
import script from "./opening-times.vue?vue&type=script&lang=js&"
export * from "./opening-times.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports